import React,{useState,useEffect} from 'react';
import Layout from './components/layout/Layout';
import DashboardView from './components/views/DashboardView';
import AlertsView from './components/views/AlertsView';
import QueueView from './components/views/QueueView';
import ZonesView from './components/views/ZonesView';
import ForecastView from './components/views/ForecastView';
import AuditLogView from './components/views/AuditLogView';
import SuppliersView from './components/views/SuppliersView';
import DemoView from './components/views/DemoView';
import {mockInventory,mockSuppliers,mockZones,initialAuditLog} from './data/mockData';

function App() {
  const [activeTab,setActiveTab]=useState('dashboard');
  const [inventory,setInventory]=useState(mockInventory);
  const [queue,setQueue]=useState([]);
  const [auditLog,setAuditLog]=useState(initialAuditLog);

  // Derived state 
  const alerts=inventory.filter(item=> item.stock <=item.minStock);

  // Actions 
  const queueItem=(item)=> {
    if (!queue.find(q=> q.id===item.id)) {
      setQueue([...queue,item]);
      setActiveTab('queue');
    }
  };

  const removeFromQueue=(id)=> {
    setQueue(queue.filter(item=> item.id !==id));
  };

  const processQueue=()=> {
    const newLogs=queue.map((item,idx)=> ({
      id: `AUD-${904 + auditLog.length + idx}`,
      timestamp: new Date().toISOString(),
      action: 'PO_GENERATED',
      user: 'Op. Alpha',
      details: `Generated PO for ${item.maxStock - item.stock} units of ${item.sku}.`
    }));

    const updatedInventory=inventory.map(item=> {
      const queuedItem=queue.find(q=> q.id===item.id);
      if (queuedItem) {
        return {...item,stock: item.maxStock};
      } 
      return item;
    });

    setInventory(updatedInventory);
    setAuditLog([...newLogs,...auditLog]);
    setQueue([]);
  };

  const renderContent=()=> {
    switch (activeTab) {
      case 'dashboard': return <DashboardView inventory={inventory} alerts={alerts} />;
      case 'demo': return <DemoView />;
      case 'alerts': return <AlertsView alerts={alerts} queueItem={queueItem} />;
      case 'queue': return <QueueView queue={queue} removeFromQueue={removeFromQueue} processQueue={processQueue} />;
      case 'zones': return <ZonesView zones={mockZones} />;
      case 'forecast': return <ForecastView />;
      case 'audit': return <AuditLogView logs={auditLog} />;
      case 'suppliers': return <SuppliersView suppliers={mockSuppliers} />;
      default: return <DashboardView inventory={inventory} alerts={alerts} />;
    }
  };

  return (
    <Layout activeTab={activeTab} setActiveTab={setActiveTab}>
      {renderContent()}
    </Layout>
  );
}

export default App;